module.exports = __webpack_public_path__ + "static/img/bottomlog.53c40b1c.png";